import { defHttp } from '@/utils/http/axios';

export const accountLogin = (params: any) => {
  return defHttp.post({ url: '/agent/account/login', params });
};

export const accountLogout = () => {
  return defHttp.get({ url: '/agent/account/logout' });
};

export const accountPermission = () => {
  return defHttp.post({ url: '/agent/store/account/permission' });
};
// 账号门店切换/agent/store/account/switch/store
export const accountSwitchStore = (params: any) => {
  return defHttp.post({ url: '/agent/store/account/switch/store', params });
};
// 账号选择角色查询/agent/store/role/query
export const accountRoleQuery = (params) => {
  return defHttp.get({ url: '/agent/store/role/query', params });
};
